export default __webpack_public_path__ + "static/charCrab-6351119a10bc72addfbd3149ed3b0c50.png";